var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.97559,
    y: 7.37582,
    width: 1.64075,
    height: 6,
    fill: "#F43F5E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.25732,
    y: 7.37581,
    width: 1.64075,
    height: 6,
    fill: "#F43F5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7185 1.80946C10.7185 1.20946 10.3904 0.809464 9.89813 0.809464H4.97589C4.48367 0.809464 4.15552 1.20946 4.15552 1.80946V3.80946H0.874023V5.80946H1.6944V15.8095C1.6944 16.4095 2.02255 16.8095 2.51477 16.8095H12.3593C12.8515 16.8095 13.1796 16.4095 13.1796 15.8095V5.80946H14V3.80946H10.7185V1.80946ZM5.79626 2.80954H9.07776V3.80954H5.79626V2.80954ZM11.5389 14.8095V5.80952H3.33514V14.8095H11.5389Z",
    fill: "#F43F5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin);
export default __webpack_public_path__ + "static/media/trashBin.eb7dd70603e0a671fc7005be10940213.svg";
export { ForwardRef as ReactComponent };